module.exports = __webpack_public_path__ + "img/404.61c9fd70.gif";